import React from 'react';
import vocabularyIds from './vocabulary.json';
import {message, normalizeLanguage} from './index';
let language = 'en';
export function setRuntimeLanguage(value) { language = normalizeLanguage(value); }
export function currentLanguage() { return language; }
// Each call is statically bound to an exported source ID. Never translates user text.
export function localize(id, fallback, vars) { return language === 'de' ? fallback : message(id, language, fallback, vars); }
const allowed = new Set(['span','em','strong','b','i']);
export function localizeRich(id, fallback, vars) {
  if (language !== 'el') return fallback;
  const text = message(id, language, null, vars);
  if (text == null) return fallback;
  const pieces = String(text).split(/(<\/?(?:span|em|strong|b|i)>|<br\s*\/>)/g);
  const root = [], stack = [{tag:null, items:root}];
  pieces.forEach((piece, i) => {
    if (/^<br/.test(piece)) stack.at(-1).items.push(<br key={i}/>);
    else if (/^<\//.test(piece) && stack.length > 1) {
      const node=stack.pop(); stack.at(-1).items.push(React.createElement(node.tag,{key:i},...node.items));
    } else if (/^</.test(piece) && allowed.has(piece.slice(1,-1))) stack.push({tag:piece.slice(1,-1),items:[]});
    else stack.at(-1).items.push(piece);
  });
  return root;
}
const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// Locale tables retain their original structure and keys. Text is resolved lazily,
// so switching accounts/languages does not freeze the module's initial language.
export function localizedDictionary(original, bindings) {
  const cache = new WeakMap();
  const resolve = (binding, value) => {
    if (!binding || language !== 'el') return value;
    const [id, source] = binding;
    if (value === source) return localize(id, value);
    const names = [...source.matchAll(/\{(\w+)\}/g)].map(m=>m[1]);
    if (!names.length) return value;
    const pattern='^'+source.split(/\{\w+\}/).map(escapePattern).join('([\\s\\S]*?)')+'$';
    const match=String(value).match(new RegExp(pattern));
    return match ? localize(id, value, Object.fromEntries(names.map((name,i)=>[name,match[i+1]]))) : value;
  };
  function wrap(target, path='') {
    if (!target || typeof target !== 'object' || React.isValidElement(target)) return target;
    if (cache.has(target)) return cache.get(target);
    const proxy = new Proxy(target, {get(obj,key) {
      const value=Reflect.get(obj,key); const full=path ? `${path}.${String(key)}` : String(key);
      if (React.isValidElement(value)) return bindings[full] ? localizeRich(bindings[full][0],value) : value;
      if (typeof value === 'string') return resolve(bindings[full],value);
      if (typeof value === 'function' && bindings[full]) return (...args)=>resolve(bindings[full],value(...args));
      return wrap(value,full);
    }});
    cache.set(target,proxy); return proxy;
  }
  return wrap(original);
}

export function vocabularyLabel(value, lang=language) {
  if (lang !== 'el') return value;
  if (vocabularyIds[value]) return message(vocabularyIds[value], lang, value);
  // Public taxonomy labels may combine a Latin name with mineral coordinates.
  // Translate only those coordinates; names and the underlying values stay exact.
  return typeof value === 'string' ? value.replace(/\b(Row|Column|Col)\s+(\d{1,2})\b/g,
    (original, kind, number) => message(`classification.${kind === 'Row' ? 'row' : 'column'}`, lang, original, {number})) : value;
}
